export default [
    {
        name: "kchfMain",
        path: "/",
        component: () => import(/* webpackChunkName: "kchf" */ "@/view/external/KCHFMain"),
        meta: {
            layout: "DefaultLayout"
        },
        hidden: true
    },
    {
        name: "support",
        path: "/support",
        alias: "/VUE_APP_DOT_SUPPORT_APP",
        beforeEnter: () => window.location.replace(process.env["VUE_APP_DOT_SUPPORT_APP"]),
    },
]